import PathwayRowContainer from './pathway_row_container';

const PathwayRow = PathwayRowContainer;
export default PathwayRow;
